const getTimeDifference = (date) => {
  const now = new Date()
  const then = new Date(date)
  const day = 1000 * 60 * 60 * 24
  const days = (now.getTime() - then.getTime()) / (day)
  let dateMessage = ''
  if (days < 1) {
    const minutes = Math.floor(days * 24 * 60)
    if (minutes < 60) {
      dateMessage = minutes + ' minutes ago'
    } else if (minutes < 120) {
      dateMessage = Math.floor(minutes / 60) + ' hour ago'
    } else {
      dateMessage = Math.floor(minutes / 60) + ' hour ago'
    }
  } else if (days < 2) {
    dateMessage = Math.floor(days) + ' day ago'
  } else {
    dateMessage = Math.floor(days) + ' days ago'
  }
  return dateMessage
}

export default getTimeDifference
